import {
  CaretDownOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Card, Col, Skeleton, Statistic, Tag, Tooltip } from "antd";
import React from "react";

export default function HomeDashboardCard({
  isLoadingRevenueKPIsData,
  isLoadingPermanenceData,
  title,
  description,
  value,
  formatter,
  suffix,
  tagValue,
  cardKey,
}) {
  const getColor = () => {
    if (tagValue > 0) return "green";
    if (tagValue < 0) return "red";
    return "orange";
  };

  const getIcon = () => {
    if (tagValue > 0) return <CaretUpOutlined />;
    if (tagValue < 0) return <CaretDownOutlined />;
    return <CaretRightOutlined />;
  };
  return (
    <>
      <Col xs={24} sm={12} lg={6}>
        <Card
          bordered={true}
          style={{
            textAlign: "center",
            position: "relative",
            height: "115px",
          }}>
          {(
            cardKey === "receita_hora"
              ? isLoadingRevenueKPIsData || isLoadingPermanenceData
              : isLoadingRevenueKPIsData
          ) ? (
            <Skeleton
              active
              paragraph={{ rows: 1, width: "100%" }}
              style={{
                height: "115px",
              }}
            />
          ) : (
            <>
              <Statistic
                title={
                  <>
                    {title}
                    <Tooltip title={description}>
                      <InfoCircleOutlined style={{ marginLeft: 10 }} />
                    </Tooltip>
                  </>
                }
                value={value}
                formatter={formatter}
                suffix={suffix}
              />
              <Tag
                color={getColor()}
                style={{ position: "absolute", bottom: "5%", right: "5%" }}>
                {getIcon()} {tagValue}%
              </Tag>
            </>
          )}
        </Card>
      </Col>
    </>
  );
}
